import { render } from "./AuthView.vue?vue&type=template&id=5b0e84a7&scoped=true"
import script from "./AuthView.vue?vue&type=script&lang=js"
export * from "./AuthView.vue?vue&type=script&lang=js"

import "./AuthView.vue?vue&type=style&index=0&id=5b0e84a7&lang=css"
import "./AuthView.vue?vue&type=style&index=1&id=5b0e84a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0e84a7"]])

export default __exports__